export function sourceFamily(value) {
  try {
    const url = new URL(value);
    const host = url.hostname.toLowerCase();
    const matches = domain => host === domain || host.endsWith(`.${domain}`);
    if (['youtube.com', 'youtu.be', 'youtube-nocookie.com'].some(matches)) return 'youtube';
    if (['drive.google.com', 'docs.google.com'].includes(host)) return 'google_drive';
    if (['dropbox.com', 'dropboxusercontent.com'].some(matches)) return 'dropbox';
    if (['soundcloud.com', 'snd.sc'].some(matches)) return 'soundcloud';
    if (['vimeo.com', 'tiktok.com', 'instagram.com', 'facebook.com', 'spotify.com'].some(matches)) return 'unsupported_platform';
    if (/\.(rss|xml)$/i.test(url.pathname)) return 'podcast';
    if (/\.(mp3|mp4|wav|m4a|m4v|ogg|opus|flac|aac|webm|mov|mpeg|wma|aiff)$/i.test(url.pathname)) return 'direct_media';
  } catch {}
  return 'other';
}

export function importMeasurements(payload = {}) {
  const families = ['youtube','google_drive','dropbox','soundcloud','podcast','direct_media','unsupported_platform','other'];
  const stages = ['url_validation','source_response','source_metadata','source_download','source_result','media_probe','preparing','captions',
    'captions_lookup','captions_fetch','captions_save'];
  const classes = ['audio','video','html','json','text','binary','unknown'];
  const reasons = ['unknown','captions_missing','captions_disabled','age_restricted','invalid_video','token_required',
    'video_unavailable','video_unplayable','proxy_blocked','request_blocked','authentication_required','rate_limited','proxy_connection',
    'connection_timeout','upstream_failed','deadline_exceeded'];
  return {
    ...(families.includes(payload.source_family) ? { url_type: payload.source_family } : {}),
    ...(stages.includes(payload.import_stage) ? { operation: `import_${payload.import_stage}` } : {}),
    ...(classes.includes(payload.content_class) ? { input_file_class: payload.content_class } : {}),
    ...(reasons.includes(payload.upstream_reason) ? {event_source:`${payload.source_family && payload.source_family !== 'youtube' ? 'source' : 'youtube'}_${payload.upstream_reason}`} : {}),
  };
}

export function soundCloudLinkIssue(value) {
  try {
    const url = new URL(value);
    if (!['soundcloud.com', 'www.soundcloud.com', 'm.soundcloud.com'].includes(url.hostname)) return null;
    const segments = url.pathname.split('/').filter(Boolean);
    if (segments.length < 2 || segments.includes('sets') || ['discover', 'stream', 'search', 'charts', 'tags', 'you'].includes(segments[0])) {
      return 'single_track_required';
    }
  } catch {}
  return null;
}
